import React from 'react';

import { Tab, Tabs, Container } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  tabs: {
    paddingTop: theme.spacing(4),
    borderBottom: `1px solid ${theme.palette.divider}`,
    marginBottom: theme.spacing(4)
  },
  tab: {
    fontWeight: theme.typography.fontWeightSemibold,
    minWidth: 0,
    textDecoration: 'none !important',
    flexDirection: 'row'
  }
}));

function a11yProps (index: number) {
  return {
    id: `nav-tab-${index}`,
    'aria-controls': `nav-tabpanel-${index}`
  };
}

function CustomTabs ({
  value,
  handleChange,
  ariaLabel,
  tabs
}: {
  value: number
  handleChange?: (event: React.ChangeEvent<{}>, newValue: number) => void
  ariaLabel: string
  tabs: {
    label: string | JSX.Element
    dataUrl: string
    root?: string
    disabled?: boolean,
    hashUrl?: boolean
  }[]
}) {
  const classes = useStyles();

  const handleUpdateUrl = (e: React.ChangeEvent<{}>) => {
    const el = e.currentTarget as HTMLInputElement;
    const url = el.getAttribute('data-url');

    if (url) {
      if (url.startsWith('#')) {
        window.history.pushState({}, '', url);
      } else if (url !== window.location.pathname + window.location.search) {
        window.location.href = url;
      }
    }
  };

  return (
    <Container maxWidth='lg'>
      <Tabs
        indicatorColor='primary'
        value={value}
        onChange={handleChange}
        aria-label={ariaLabel}
        variant='scrollable'
        className={classes.tabs}
      >
        {tabs.map(({ label, dataUrl, root, disabled, hashUrl }, index) => (
          <Tab
            label={label}
            disabled={disabled}
            {...a11yProps(index)}
            className={classes.tab}
            classes={{ root }}
            data-url={hashUrl !== false ? `#${dataUrl}` : dataUrl}
            onClick={handleUpdateUrl}
            key={index}
          />
        ))}
      </Tabs>
    </Container>
  );
}

export default CustomTabs;
